import React, { FunctionComponent } from "react";
import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const ComingSoonBadge: FunctionComponent = () => {
	const { t } = useTranslation();
	return (
		<Box display="flex" alignItems="center" textColor="neutrals.800" bg="neutrals.50" borderRadius="md" px={2} py={0.5}>
			<Text fontSize="xs" fontWeight={600}>
				{t("classroomDetails.comingSoonBadge")}
			</Text>
		</Box>
	);
};
